<div class="label justify-end">
  {{
    'communication.message.system.cases.team-changed'
      | translate: { old: this.case().OldTeamName ?? '', new: this.case().NewTeamName ?? '' }
  }}
</div>
